__webpack_require__.p = "/sistem-minimed-780g/";